module.exports = __webpack_public_path__ + "media/src/images/logos/facebook-bf51523eb98aa0f71229fe8cc7b5596b.png";